module.exports = __webpack_public_path__ + "img/shouye_b.ea6ee086.png";